<template>
  <div id="app">
    <!-- <main-layout/> -->
    <router-view></router-view>
  </div>
   
</template>
<script src="//unpkg.com/tinymce@5.1.5/tinymce.min.js"></script>
<script>
import MainLayout from './components/layout/MainLayout.vue'
import {test} from "@/utils/PerformanceUtils"
export default {
  name: 'App',
  data(){
    return {
      
    }
  },
  components: {
    MainLayout
  },
  created(){
    
  },
  mounted(){
  },
  methods:{
  }
}
</script>
<style scoped>
#app{
  width: 100%;
  height: 100%;
}
</style>